import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutosaveSettingsComponent } from './autosave-settings/autosave-settings.component';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateModule } from '@ngx-translate/core';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { RouterModule } from '@angular/router';
import { AutosaveService } from './autosave.service';
import { AutosaveSimpleSelectorComponent } from './autosave-simple-selector/autosave-simple-selector.component';

@NgModule({
  imports: [
    CommonModule,
    BrightsideUiModule,
    TranslateModule,
    MicroUiMoleculeModule,
    SharedDesktopModule,
    RouterModule.forChild([
      {
        path: '',
        component: AutosaveSettingsComponent,
      },
    ]),
  ],
  declarations: [AutosaveSettingsComponent, AutosaveSimpleSelectorComponent],  
  providers: [AutosaveService],
})
export class DesktopFeatureAutosaveModule {}
